import {useGetConsumablesV1CMQuery} from "../../core/api/clockmaker-analytical-data-api";
import {
    Box, Card,
    CardActionArea,
    CardActions, CardContent,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import Loading from "../../components/Common/Loading";
import {DataGrid} from "@mui/x-data-grid";
import {useState} from "react";
import {format, subDays} from "date-fns";

const columns = [
    {
        headerName: "ID",
        field: "userFk",
        flex: 1
    },
    {
        headerName: 'Item',
        field: 'itemName',
        flex: 1
    },
    {
        headerName: 'Amount',
        field: 'amount',
        flex: 1
    },
    {
        headerName: 'Reason name',
        field: 'reasonName',
        flex: 1
    },
    {
        headerName: 'Timestamp',
        field: 'timestamp',
        flex: 1,
        renderCell: (params) =>
            <div>{format(Date.parse(params.row.timestamp), "dd.MM.yyyy HH:mm:ss")}</div>
    },
    {
        headerName: 'Offer name',
        field: 'offerName',
        flex: 1
    }
]

const ConsumablesCM = (props) => {
    const [filterText, setFilterText] = useState("");

    const [fromDate, setFromDate] = useState( format(subDays(new Date(), 30), 'yyyy-MM-dd'));
    const [toDate, setToDate] = useState( format(new Date(), 'yyyy-MM-dd') );

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
        isFetching
    } = useGetConsumablesV1CMQuery({
        "userId": props.deviceId,
        "depth": props.depth,
        "from": fromDate,
        "to": toDate
    }, {
        skip: !props.deviceId || props.deviceId.trim() === ""
    })

    function filterData() {
        let newData = [...data.rows]
        return newData.filter(item => item.itemName !== null && (
            item.itemName.toLowerCase().includes(filterText.toLowerCase())
            || item.reasonName.toLowerCase().includes(filterText.toLowerCase())
            || item.offerName.toLowerCase().includes(filterText.toLowerCase())
            || item.hasOwnProperty("amount") && item.amount != null && item.amount.toString().includes(filterText.toLowerCase()))
        );
    }

    let consumables = ""

    if (typeof data === "object") {
        consumables = <DataGrid
            loading={isLoading}
            getRowId={(row) => row.id}
            rows={filterData()}
            columns={columns}
            pagination={true}
            paginationMode="client"
            pageSizeOptions={[100]}
            autoHeight

        />
    } else {
        consumables = "no data"
    }

    return (
        <>
            <Card>
                <CardActions>
                    <Grid container spacing={2}  sx={{pt:2}}>
                        <Grid>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-end"
                                }}>
                                <TextField
                                    size="small"
                                    label="Filter"
                                    onChange={(e) => setFilterText(e.target.value)}>
                                </TextField>
                            </Box>
                        </Grid>

                        <Grid>
                            <TextField
                                size="small"
                                label="From Date"
                                type="date"
                                value={fromDate}
                                onChange={handleFromDateChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid>
                            <TextField
                                size="small"
                                label="To Date"
                                type="date"
                                value={toDate}
                                onChange={handleToDateChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                </CardActions>

                    <Loading
                        isLoading={isLoading||isFetching}
                        isError={isError}
                        error={error}
                        isSuccess={isSuccess}
                    >

                        {consumables}

                    </Loading>
            </Card>
        </>
    );
}

export default ConsumablesCM
